/** 로비·회원·섯다 게임 등 기본 앱 구역 (`app/games_seotda/*`) */
export const SEOTDA_APP_BASE = "/games_seotda" as const;

/**
 * 홀덤 번들 (`app/games_holdem/*`). 로비 UI는 `components/lobby/MainLobbyPage` 공유.
 * 전용 BE 인스턴스를 둘 때는 `NEXT_PUBLIC_BE_HTTP_HOLDEM` / `NEXT_PUBLIC_BE_WS_HOLDEM` + 브라우저가 이 베이스 아래에 있어야 한다.
 */
export const HOLDEM_APP_BASE = "/games_holdem" as const;

/** `/games_seotda` 아래 경로 (선행 슬래시 없이 `login`, `money` 등) */
export function seotdaPath(pathWithoutBase: string): string {
  const p = pathWithoutBase.startsWith("/") ? pathWithoutBase.slice(1) : pathWithoutBase;
  return p ? `${SEOTDA_APP_BASE}/${p}` : SEOTDA_APP_BASE;
}

export function seotdaGamePath(lobbyKey: string, tableId?: string): string {
  let out = `${SEOTDA_APP_BASE}/game/${lobbyKey}`;
  if (tableId) out += `?table=${encodeURIComponent(tableId)}`;
  return out;
}

export function holdemGamePath(lobbyKey: string, tableId?: string): string {
  let out = `${HOLDEM_APP_BASE}/game/${lobbyKey}`;
  if (tableId) out += `?table=${encodeURIComponent(tableId)}`;
  return out;
}

export function gamePathForLobbyType(
  lobbyGameType: "SEOTDA" | "HOLDEM",
  lobbyKey: string,
  tableId?: string,
): string {
  return lobbyGameType === "HOLDEM" ? holdemGamePath(lobbyKey, tableId) : seotdaGamePath(lobbyKey, tableId);
}

/** 게임 이탈 시 로비(섯다 구역 홈) */
export function lobbyHomePath(): string {
  return SEOTDA_APP_BASE;
}
